import { COLOR } from 'vars/index'

export const ErrorMessageBackground = {
  ADDITIONAL_RED_2: COLOR.ADDITIONAL_RED_2,
  ADDITIONAL_ORANGE: COLOR.ADDITIONAL_ORANGE,
} as const
export type ErrorMessageBackground =
  (typeof ErrorMessageBackground)[keyof typeof ErrorMessageBackground]
